"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    REGULAR: 'regular',
    VIP: 'vip',
};
//# sourceMappingURL=studentType.js.map